const apis = {
    get_company: "/cuenta/usuario/empresa/",
    update_company: "/cuenta/usuario/actualizar/empresa",
    update_p12: "/cuenta/usuario/registro/certificado",
    put_update_pass: "/cuenta/usuario/contrasenia",
    update_qr_security_code: "/admin/empresas/afiliacion-codigo-seguridad-qr/dgi",
    affiliation_company_pac: "/admin/empresas/afiliacion-empresa-pac/dgi",
}

export default apis;